// Generated by packages/react-components/scripts/generate-cas-tokens.js from
// the CAS Design System Figma exports in packages/react-components/cas-tokens.
// Do not edit by hand: re-export from Figma and run `yarn cas-tokens:generate`.

/** Figma collection "primitives", mode "Value" (ARIA ramps left out). */
export const casPrimitives = {
  brand: {
    crn: {
      '25': [226, 238, 237],
      '50': [209, 236, 225],
      '100': [191, 227, 211],
      '200': [159, 211, 187],
      '300': [126, 195, 162],
      '400': [92, 178, 137],
      '500': [52, 162, 112],
      '600': [48, 148, 102],
      '700': [44, 134, 92],
      '800': [40, 121, 83],
      '900': [36, 108, 74],
      '900-A4': [36, 108, 74, 0.04],
      '900-A8': [36, 108, 74, 0.08],
      '900-A12': [36, 108, 74, 0.12],
      '900-A16': [36, 108, 74, 0.16],
      '900-A20': [36, 108, 74, 0.2],
      '900-A24': [36, 108, 74, 0.24],
      '900-A32': [36, 108, 74, 0.32],
      '900-A36': [36, 108, 74, 0.36],
      '900-A40': [36, 108, 74, 0.4],
    },
    gp2: {
      '25': [230, 243, 249],
      '50': [211, 233, 243],
      '100': [192, 223, 237],
      '200': [155, 203, 226],
      '300': [117, 183, 216],
      '400': [76, 162, 205],
      '500': [12, 141, 195],
      '600': [6, 129, 178],
      '700': [3, 117, 162],
      '800': [0, 106, 146],
      '900': [0, 95, 131],
      '900-A4': [0, 95, 131, 0.04],
      '900-A8': [0, 95, 131, 0.08],
      '900-A12': [0, 95, 131, 0.12],
      '900-A16': [0, 95, 131, 0.16],
      '900-A20': [0, 95, 131, 0.2],
      '900-A24': [0, 95, 131, 0.24],
      '900-A32': [0, 95, 131, 0.32],
      '900-A36': [0, 95, 131, 0.36],
      '900-A40': [0, 95, 131, 0.4],
    },
  },
  general: {
    blue: {
      cerulean: {
        '25': [238, 243, 246],
        '50': [221, 231, 238],
        '100': [208, 222, 231],
        '200': [186, 208, 220],
        '300': [169, 196, 211],
        '400': [152, 184, 203],
        '500': [135, 172, 194],
        '600': [117, 161, 185],
        '700': [100, 149, 177],
        '800': [83, 137, 168],
        '900': [59, 97, 119],
      },
      peacock: {
        '25': [235, 240, 243],
        '50': [211, 221, 228],
        '100': [194, 209, 218],
        '200': [174, 193, 206],
        '300': [154, 178, 193],
        '400': [134, 163, 181],
        '500': [114, 147, 169],
        '600': [93, 132, 157],
        '700': [73, 116, 144],
        '800': [53, 101, 132],
        '900': [42, 59, 93],
      },
      classic: {
        '25': [236, 238, 242],
        '50': [212, 217, 226],
        '100': [197, 203, 216],
        '200': [177, 186, 203],
        '300': [157, 168, 190],
        '400': [138, 151, 177],
        '500': [115, 133, 167],
        '600': [96, 115, 154],
        '700': [80, 99, 137],
        '800': [67, 84, 118],
        '900': [42, 59, 93],
      },
    },
    purple: {
      lavender: {
        '25': [243, 243, 249],
        '50': [231, 232, 242],
        '100': [219, 221, 235],
        '200': [209, 211, 230],
        '300': [195, 197, 223],
        '400': [183, 186, 216],
        '500': [171, 175, 209],
        '600': [159, 163, 203],
        '700': [147, 151, 197],
        '800': [135, 140, 190],
        '900': [82, 89, 152],
      },
      iris: {
        '25': [238, 238, 244],
        '50': [224, 225, 235],
        '100': [212, 212, 227],
        '200': [188, 188, 210],
        '300': [169, 169, 198],
        '400': [152, 152, 187],
        '500': [135, 135, 175],
        '600': [117, 118, 164],
        '700': [100, 101, 152],
        '800': [83, 84, 141],
        '900': [64, 65, 109],
      },
    },
    green: {
      '25': [238, 246, 248],
      '50': [222, 238, 240],
      '100': [205, 229, 233],
      '200': [188, 220, 225],
      '300': [171, 211, 218],
      '400': [155, 203, 211],
      '500': [138, 194, 203],
      '600': [121, 185, 196],
      '700': [105, 177, 188],
      '800': [88, 168, 181],
      '900': [62, 103, 126],
    },
    yellow: {
      '25': [255, 251, 240],
      '50': [255, 245, 219],
      '100': [254, 242, 205],
      '200': [255, 235, 184],
      '300': [255, 227, 153],
      '400': [255, 220, 128],
      '500': [255, 213, 102],
      '600': [255, 200, 54],
      '700': [240, 174, 0],
      '800': [184, 133, 0],
      '900': [128, 93, 0],
    },
    gradient: {
      'lavender-dream': {
        '1': [189, 180, 254],
        '2': [250, 167, 224],
      },
      'sunset-peach': {
        '1': [253, 162, 155],
        '2': [254, 200, 75],
      },
      'ocean-mint': {
        '1': [117, 224, 167],
        '2': [132, 202, 255],
      },
      'citrus-groove': {
        '1': [254, 200, 75],
        '2': [170, 223, 146],
      },
      'coral-bloom': {
        '1': [250, 167, 224],
        '2': [253, 162, 155],
      },
    },
    orange: {
      '50': [252, 247, 240],
      '100': [248, 237, 222],
      '200': [239, 214, 185],
      '300': [229, 186, 140],
      '400': [218, 150, 93],
      '500': [209, 123, 62],
      '600': [195, 101, 51],
      '700': [162, 79, 44],
      '800': [130, 64, 42],
      '900': [105, 55, 37],
    },
  },
  neutral: {
    '0': [255, 255, 255],
    '25': [252, 252, 253],
    '50': [250, 250, 250],
    '100': [227, 230, 232],
    '150': [212, 214, 216],
    '200': [197, 202, 206],
    '300': [166, 174, 180],
    '400': [136, 147, 154],
    '500': [104, 120, 131],
    '600': [86, 96, 102],
    '700': [75, 83, 89],
    '800': [51, 57, 61],
    '900': [28, 31, 33],
    '900-A4': [28, 31, 33, 0.04],
    '900-A8': [28, 31, 33, 0.08],
    '900-A12': [28, 31, 33, 0.12],
    '900-A16': [28, 31, 33, 0.16],
    '900-A20': [28, 31, 33, 0.2],
    '900-A24': [28, 31, 33, 0.24],
    '900-A32': [28, 31, 33, 0.32],
    '900-A36': [28, 31, 33, 0.36],
    '900-A40': [28, 31, 33, 0.4],
  },
  utilitarian: {
    green: {
      '50': [241, 252, 246],
      '100': [220, 250, 230],
      '200': [169, 239, 197],
      '300': [117, 224, 167],
      '400': [71, 205, 137],
      '500': [23, 178, 106],
      '600': [7, 148, 85],
      '700': [6, 118, 71],
      '800': [8, 93, 58],
      '900': [7, 77, 49],
    },
    blue: {
      '50': [239, 248, 255],
      '100': [209, 233, 255],
      '200': [178, 221, 255],
      '300': [132, 202, 255],
      '400': [83, 177, 253],
      '500': [46, 144, 250],
      '600': [21, 112, 239],
      '700': [23, 92, 211],
      '800': [24, 73, 169],
      '900': [25, 65, 133],
    },
    orange: {
      '2': {
        '50': [252, 247, 240],
        '100': [248, 237, 222],
        '200': [239, 214, 185],
        '300': [229, 186, 140],
        '400': [218, 150, 93],
        '500': [209, 123, 62],
        '600': [195, 101, 51],
        '700': [162, 79, 44],
        '800': [130, 64, 42],
        '900': [105, 55, 37],
      },
      '50': [252, 248, 238],
      '100': [254, 240, 199],
      '200': [254, 223, 137],
      '300': [254, 200, 75],
      '400': [253, 176, 34],
      '500': [247, 144, 9],
      '600': [220, 104, 3],
      '700': [181, 71, 8],
      '800': [147, 55, 13],
      '900': [122, 46, 14],
    },
    red: {
      '50': [254, 243, 242],
      '100': [254, 228, 226],
      '200': [254, 205, 202],
      '300': [253, 162, 155],
      '400': [249, 112, 102],
      '500': [240, 68, 56],
      '600': [217, 45, 32],
      '700': [180, 35, 24],
      '800': [145, 32, 24],
      '900': [131, 27, 20],
    },
    yellow: {
      '50': [255, 245, 219],
      '100': [254, 242, 205],
      '200': [255, 235, 184],
      '300': [255, 227, 153],
      '400': [255, 220, 128],
      '500': [255, 213, 102],
      '600': [255, 200, 54],
      '700': [240, 174, 0],
      '800': [184, 133, 0],
      '900': [128, 93, 0],
    },
    aqua: {
      '50': [222, 238, 240],
      '100': [205, 229, 233],
      '200': [188, 220, 225],
      '300': [171, 211, 218],
      '400': [155, 203, 211],
      '500': [138, 194, 203],
      '600': [121, 185, 196],
      '700': [105, 177, 188],
      '800': [88, 168, 181],
      '900': [62, 103, 126],
    },
  },
} as const;

/** Figma collection "theme", modes "CRN" and "GP2", resolved to values. */
export const casTheme = {
  crn: {
    'colour/foreground/primary': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
      production: '#00222C',
    },
    'colour/foreground/secondary': {
      hex: '#33393D',
      alpha: 1,
      alias: 'colour/neutral/800',
    },
    'colour/foreground/tertiary': {
      hex: '#4B5359',
      alpha: 1,
      alias: 'colour/neutral/700',
      production: '#4D646B',
    },
    'colour/foreground/quaternary': {
      hex: '#687883',
      alpha: 1,
      alias: 'colour/neutral/500',
      production: '#92999E',
    },
    'colour/foreground/primary-inverse': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FFFFFF',
    },
    'colour/foreground/secondary-inverse': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/foreground/tertiary-inverse': {
      hex: '#C5CACE',
      alpha: 1,
      alias: 'colour/neutral/200',
    },
    'colour/foreground/quaternary-inverse': {
      hex: '#A6AEB4',
      alpha: 1,
      alias: 'colour/neutral/300',
    },
    'colour/foreground/disabled': {
      hex: '#A6AEB4',
      alpha: 1,
      alias: 'colour/neutral/300',
      production: '#C2C9CE',
    },
    'colour/foreground/brand': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
      production: '#34A270',
    },
    'colour/foreground/color-yellow': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/general/orange/600',
    },
    'colour/foreground/color-brand': {
      hex: '#356A25',
      alpha: 1,
      alias: 'colour/brand/aria/2/900',
    },
    'colour/foreground/color-green': {
      hex: '#3E677E',
      alpha: 1,
      alias: 'colour/general/green/900',
    },
    'colour/foreground/color-lavender': {
      hex: '#525998',
      alpha: 1,
      alias: 'colour/general/purple/lavender/900',
    },
    'colour/foreground/color-blue': {
      hex: '#435476',
      alpha: 1,
      alias: 'colour/general/blue/classic/800',
    },
    'colour/foreground/info': {
      hex: '#0681B2',
      alpha: 1,
      alias: 'colour/brand/gp2/600',
      production: '#0C8DC3',
    },
    'colour/foreground/success': {
      hex: '#309466',
      alpha: 1,
      alias: 'colour/brand/crn/600',
      production: '#34A270',
    },
    'colour/foreground/warning': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
      production: '#CE801A',
    },
    'colour/foreground/error': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
      production: '#CD1426',
    },
    'colour/foreground/neutral': {
      hex: '#4B5359',
      alpha: 1,
      alias: 'colour/neutral/700',
    },
    'colour/foreground/button/primary/default': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FFFFFF',
    },
    'colour/foreground/button/primary/hover': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FFFFFF',
    },
    'colour/foreground/button/secondary/default': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
    },
    'colour/foreground/button/secondary/hover': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
    },
    'colour/foreground/button/tertiary/default': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
    },
    'colour/foreground/button/tertiary/hover': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
    },
    'colour/background/primary': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
      production: '#FFFFFF',
    },
    'colour/background/secondary': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FCFDFE',
    },
    'colour/background/tertiary': {
      hex: '#EEF3F6',
      alpha: 1,
      alias: 'colour/general/blue/cerulean/25',
      production: '#EDF1F3',
    },
    'colour/background/quaternary': {
      hex: '#ECEEF2',
      alpha: 1,
      alias: 'colour/general/blue/classic/25',
    },
    'colour/background/highlight': {
      hex: '#E2EEED',
      alpha: 1,
      alias: 'colour/brand/crn/25',
    },
    'colour/background/active': {
      hex: '#D1ECE1',
      alpha: 1,
      alias: 'colour/brand/crn/50',
      production: '#E7F7F0',
    },
    'colour/background/hover': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/background/hover-brand': {
      hex: '#E2EEED',
      alpha: 1,
      alias: 'colour/brand/crn/25',
      production: '#E4F5EE',
    },
    'colour/background/hover-brand-inverse': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
      production: '#287953',
    },
    'colour/background/disabled': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
      production: '#EDF1F3',
    },
    'colour/background/brand': {
      hex: '#E2EEED',
      alpha: 1,
      alias: 'colour/brand/crn/25',
    },
    'colour/background/brand-inverse': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
      production: '#34A270',
    },
    'colour/background/color-yellow': {
      hex: '#F8EDDE',
      alpha: 1,
      alias: 'colour/general/orange/100',
    },
    'colour/background/color-brand': {
      hex: '#D1ECE1',
      alpha: 1,
      alias: 'colour/brand/crn/50',
    },
    'colour/background/color-green': {
      hex: '#CDE5E9',
      alpha: 1,
      alias: 'colour/general/green/100',
    },
    'colour/background/color-lavender': {
      hex: '#D1D3E6',
      alpha: 1,
      alias: 'colour/general/purple/lavender/200',
    },
    'colour/background/color-blue': {
      hex: '#D4D9E2',
      alpha: 1,
      alias: 'colour/general/blue/classic/50',
    },
    'colour/background/info': {
      hex: '#D3E9F3',
      alpha: 1,
      alias: 'colour/brand/gp2/50',
      production: '#E6F3F9',
    },
    'colour/background/info-inverse': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
    },
    'colour/background/success': {
      hex: '#D1ECE1',
      alpha: 1,
      alias: 'colour/brand/crn/50',
      production: '#E4F5EE',
    },
    'colour/background/success-inverse': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
    },
    'colour/background/warning': {
      hex: '#F8EDDE',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/100',
      production: '#F8EDDE',
    },
    'colour/background/warning-inverse': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
    },
    'colour/background/error': {
      hex: '#FEE4E2',
      alpha: 1,
      alias: 'colour/utilitarian/red/100',
      production: '#F7E8EA',
    },
    'colour/background/error-inverse': {
      hex: '#D92D20',
      alpha: 1,
      alias: 'colour/utilitarian/red/600',
    },
    'colour/background/neutral': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/background/overlay': {
      hex: '#1C1F21',
      alpha: 0.2,
      alias: 'colour/neutral/900-A20',
    },
    'colour/background/button/primary/default': {
      hex: '#309466',
      alpha: 1,
      alias: 'colour/brand/crn/600',
      production: '#34A270',
    },
    'colour/background/button/primary/hover': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
      production: '#287953',
    },
    'colour/background/button/secondary/default': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/background/button/secondary/hover': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/background/button/secondary/hover-level-2': {
      hex: '#FFFFFF',
      alpha: 0,
    },
    'colour/background/button/tertiary/default': {
      hex: '#FFFFFF',
      alpha: 0,
    },
    'colour/background/button/tertiary/hover': {
      hex: '#FFFFFF',
      alpha: 0,
    },
    'colour/background/button/utilitarian/error/default': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
      production: '#CD1426',
    },
    'colour/background/button/utilitarian/error/hover': {
      hex: '#912018',
      alpha: 1,
      alias: 'colour/utilitarian/red/800',
      production: '#B00A1A',
    },
    'colour/background/button/utilitarian/info/default': {
      hex: '#0681B2',
      alpha: 1,
      alias: 'colour/brand/gp2/600',
    },
    'colour/background/button/utilitarian/info/hover': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
    },
    'colour/background/button/utilitarian/success/default': {
      hex: '#309466',
      alpha: 1,
      alias: 'colour/brand/crn/600',
    },
    'colour/background/button/utilitarian/success/hover': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
    },
    'colour/background/button/utilitarian/warning/default': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
    },
    'colour/background/button/utilitarian/warning/hover': {
      hex: '#A24F2C',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/700',
    },
    'colour/background/input/default': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/background/input/hover': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/border/primary': {
      hex: '#A6AEB4',
      alpha: 1,
      alias: 'colour/neutral/300',
    },
    'colour/border/secondary': {
      hex: '#C5CACE',
      alpha: 1,
      alias: 'colour/neutral/200',
      production: '#C2C9CE',
    },
    'colour/border/tertiary': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
      production: '#DFE5EA',
    },
    'colour/border/disabled': {
      hex: '#C5CACE',
      alpha: 1,
      alias: 'colour/neutral/200',
      production: '#DFE5EA',
    },
    'colour/border/brand': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
      production: '#34A270',
    },
    'colour/border/info': {
      hex: '#006A92',
      alpha: 1,
      alias: 'colour/brand/gp2/800',
      production: '#0C8DC3',
    },
    'colour/border/success': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
      production: '#287953',
    },
    'colour/border/warning': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
      production: '#CE801A',
    },
    'colour/border/error': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
      production: '#CD1426',
    },
    'colour/border/neutral': {
      hex: '#687883',
      alpha: 1,
      alias: 'colour/neutral/500',
    },
    'colour/border/button/primary/default': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
      production: '#287953',
    },
    'colour/border/button/primary/hover': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
      production: '#287953',
    },
    'colour/border/button/secondary/default': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/border/button/secondary/hover': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
    },
    'colour/border/button/tertiary/default': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
    },
    'colour/border/button/tertiary/hover': {
      hex: '#912018',
      alpha: 1,
      alias: 'colour/utilitarian/red/800',
    },
    'colour/border/card/default': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/border/tertiary',
    },
    'colour/border/view-more/default': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/border/tertiary',
    },
  },
  gp2: {
    'colour/foreground/primary': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
      production: '#00222C',
    },
    'colour/foreground/secondary': {
      hex: '#33393D',
      alpha: 1,
      alias: 'colour/neutral/800',
    },
    'colour/foreground/tertiary': {
      hex: '#4B5359',
      alpha: 1,
      alias: 'colour/neutral/700',
      production: '#4D646B',
    },
    'colour/foreground/quaternary': {
      hex: '#687883',
      alpha: 1,
      alias: 'colour/neutral/500',
      production: '#92999E',
    },
    'colour/foreground/primary-inverse': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FFFFFF',
    },
    'colour/foreground/secondary-inverse': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/foreground/tertiary-inverse': {
      hex: '#C5CACE',
      alpha: 1,
      alias: 'colour/neutral/200',
    },
    'colour/foreground/quaternary-inverse': {
      hex: '#A6AEB4',
      alpha: 1,
      alias: 'colour/neutral/300',
    },
    'colour/foreground/disabled': {
      hex: '#A6AEB4',
      alpha: 1,
      alias: 'colour/neutral/300',
      production: '#C2C9CE',
    },
    'colour/foreground/brand': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
      production: '#0C8DC3',
    },
    'colour/foreground/color-yellow': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/general/orange/600',
    },
    'colour/foreground/color-brand': {
      hex: '#356A25',
      alpha: 1,
      alias: 'colour/brand/aria/2/900',
    },
    'colour/foreground/color-green': {
      hex: '#3E677E',
      alpha: 1,
      alias: 'colour/general/green/900',
    },
    'colour/foreground/color-lavender': {
      hex: '#525998',
      alpha: 1,
      alias: 'colour/general/purple/lavender/900',
    },
    'colour/foreground/color-blue': {
      hex: '#435476',
      alpha: 1,
      alias: 'colour/general/blue/classic/800',
    },
    'colour/foreground/info': {
      hex: '#0681B2',
      alpha: 1,
      alias: 'colour/brand/gp2/600',
      production: '#0C8DC3',
    },
    'colour/foreground/success': {
      hex: '#309466',
      alpha: 1,
      alias: 'colour/brand/crn/600',
      production: '#34A270',
    },
    'colour/foreground/warning': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
      production: '#CE801A',
    },
    'colour/foreground/error': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
      production: '#CD1426',
    },
    'colour/foreground/neutral': {
      hex: '#4B5359',
      alpha: 1,
      alias: 'colour/neutral/700',
    },
    'colour/foreground/button/primary/default': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FFFFFF',
    },
    'colour/foreground/button/primary/hover': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FFFFFF',
    },
    'colour/foreground/button/secondary/default': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
    },
    'colour/foreground/button/secondary/hover': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
    },
    'colour/foreground/button/tertiary/default': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
    },
    'colour/foreground/button/tertiary/hover': {
      hex: '#006A92',
      alpha: 1,
      alias: 'colour/brand/gp2/800',
    },
    'colour/background/primary': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
      production: '#FFFFFF',
    },
    'colour/background/secondary': {
      hex: '#FCFCFD',
      alpha: 1,
      alias: 'colour/neutral/25',
      production: '#FCFDFE',
    },
    'colour/background/tertiary': {
      hex: '#EEF3F6',
      alpha: 1,
      alias: 'colour/general/blue/cerulean/25',
      production: '#EDF1F3',
    },
    'colour/background/quaternary': {
      hex: '#ECEEF2',
      alpha: 1,
      alias: 'colour/general/blue/classic/25',
    },
    'colour/background/highlight': {
      hex: '#E6F3F9',
      alpha: 1,
      alias: 'colour/brand/gp2/25',
    },
    'colour/background/active': {
      hex: '#D3E9F3',
      alpha: 1,
      alias: 'colour/brand/gp2/50',
      production: '#E6F3F9',
    },
    'colour/background/hover': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/background/hover-brand': {
      hex: '#E6F3F9',
      alpha: 1,
      alias: 'colour/brand/gp2/25',
      production: '#E6F3F9',
    },
    'colour/background/hover-brand-inverse': {
      hex: '#0681B2',
      alpha: 1,
      alias: 'colour/brand/gp2/600',
      production: '#006A92',
    },
    'colour/background/disabled': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
      production: '#EDF1F3',
    },
    'colour/background/brand': {
      hex: '#E6F3F9',
      alpha: 1,
      alias: 'colour/brand/gp2/25',
    },
    'colour/background/brand-inverse': {
      hex: '#006A92',
      alpha: 1,
      alias: 'colour/brand/gp2/800',
      production: '#0C8DC3',
    },
    'colour/background/color-yellow': {
      hex: '#F8EDDE',
      alpha: 1,
      alias: 'colour/general/orange/100',
    },
    'colour/background/color-brand': {
      hex: '#D3E9F3',
      alpha: 1,
      alias: 'colour/brand/gp2/50',
    },
    'colour/background/color-green': {
      hex: '#CDE5E9',
      alpha: 1,
      alias: 'colour/general/green/100',
    },
    'colour/background/color-lavender': {
      hex: '#D1D3E6',
      alpha: 1,
      alias: 'colour/general/purple/lavender/200',
    },
    'colour/background/color-blue': {
      hex: '#D4D9E2',
      alpha: 1,
      alias: 'colour/general/blue/classic/50',
    },
    'colour/background/info': {
      hex: '#D3E9F3',
      alpha: 1,
      alias: 'colour/brand/gp2/50',
      production: '#E6F3F9',
    },
    'colour/background/info-inverse': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
    },
    'colour/background/success': {
      hex: '#D1ECE1',
      alpha: 1,
      alias: 'colour/brand/crn/50',
      production: '#E4F5EE',
    },
    'colour/background/success-inverse': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
    },
    'colour/background/warning': {
      hex: '#F8EDDE',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/100',
      production: '#F8EDDE',
    },
    'colour/background/warning-inverse': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
    },
    'colour/background/error': {
      hex: '#FEE4E2',
      alpha: 1,
      alias: 'colour/utilitarian/red/100',
      production: '#F7E8EA',
    },
    'colour/background/error-inverse': {
      hex: '#D92D20',
      alpha: 1,
      alias: 'colour/utilitarian/red/600',
    },
    'colour/background/neutral': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/background/overlay': {
      hex: '#1C1F21',
      alpha: 0.2,
      alias: 'colour/neutral/900-A20',
    },
    'colour/background/button/primary/default': {
      hex: '#0681B2',
      alpha: 1,
      alias: 'colour/brand/gp2/600',
      production: '#0C8DC3',
    },
    'colour/background/button/primary/hover': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
      production: '#006A92',
    },
    'colour/background/button/secondary/default': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/background/button/secondary/hover': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/background/button/secondary/hover-level-2': {
      hex: '#FFFFFF',
      alpha: 0,
    },
    'colour/background/button/tertiary/default': {
      hex: '#FFFFFF',
      alpha: 0,
    },
    'colour/background/button/tertiary/hover': {
      hex: '#FFFFFF',
      alpha: 0,
    },
    'colour/background/button/utilitarian/error/default': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
      production: '#CD1426',
    },
    'colour/background/button/utilitarian/error/hover': {
      hex: '#912018',
      alpha: 1,
      alias: 'colour/utilitarian/red/800',
      production: '#B00A1A',
    },
    'colour/background/button/utilitarian/info/default': {
      hex: '#0681B2',
      alpha: 1,
      alias: 'colour/brand/gp2/600',
    },
    'colour/background/button/utilitarian/info/hover': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
    },
    'colour/background/button/utilitarian/success/default': {
      hex: '#309466',
      alpha: 1,
      alias: 'colour/brand/crn/600',
    },
    'colour/background/button/utilitarian/success/hover': {
      hex: '#2C865C',
      alpha: 1,
      alias: 'colour/brand/crn/700',
    },
    'colour/background/button/utilitarian/warning/default': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
    },
    'colour/background/button/utilitarian/warning/hover': {
      hex: '#A24F2C',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/700',
    },
    'colour/background/input/default': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/background/input/hover': {
      hex: '#FFFFFF',
      alpha: 1,
      alias: 'colour/neutral/0',
    },
    'colour/border/primary': {
      hex: '#A6AEB4',
      alpha: 1,
      alias: 'colour/neutral/300',
    },
    'colour/border/secondary': {
      hex: '#C5CACE',
      alpha: 1,
      alias: 'colour/neutral/200',
      production: '#C2C9CE',
    },
    'colour/border/tertiary': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
      production: '#DFE5EA',
    },
    'colour/border/disabled': {
      hex: '#C5CACE',
      alpha: 1,
      alias: 'colour/neutral/200',
      production: '#DFE5EA',
    },
    'colour/border/brand': {
      hex: '#006A92',
      alpha: 1,
      alias: 'colour/brand/gp2/800',
      production: '#0C8DC3',
    },
    'colour/border/info': {
      hex: '#006A92',
      alpha: 1,
      alias: 'colour/brand/gp2/800',
      production: '#0C8DC3',
    },
    'colour/border/success': {
      hex: '#287953',
      alpha: 1,
      alias: 'colour/brand/crn/800',
      production: '#287953',
    },
    'colour/border/warning': {
      hex: '#C36533',
      alpha: 1,
      alias: 'colour/utilitarian/orange/2/600',
      production: '#CE801A',
    },
    'colour/border/error': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
      production: '#CD1426',
    },
    'colour/border/neutral': {
      hex: '#687883',
      alpha: 1,
      alias: 'colour/neutral/500',
    },
    'colour/border/button/primary/default': {
      hex: '#0375A2',
      alpha: 1,
      alias: 'colour/brand/gp2/700',
      production: '#006A92',
    },
    'colour/border/button/primary/hover': {
      hex: '#006A92',
      alpha: 1,
      alias: 'colour/brand/gp2/800',
      production: '#006A92',
    },
    'colour/border/button/secondary/default': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/neutral/100',
    },
    'colour/border/button/secondary/hover': {
      hex: '#1C1F21',
      alpha: 1,
      alias: 'colour/neutral/900',
    },
    'colour/border/button/tertiary/default': {
      hex: '#B42318',
      alpha: 1,
      alias: 'colour/utilitarian/red/700',
    },
    'colour/border/button/tertiary/hover': {
      hex: '#912018',
      alpha: 1,
      alias: 'colour/utilitarian/red/800',
    },
    'colour/border/card/default': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/border/tertiary',
    },
    'colour/border/view-more/default': {
      hex: '#E3E6E8',
      alpha: 1,
      alias: 'colour/border/tertiary',
    },
  },
} as const;

/** CSS custom property for every theme token, named after its Figma path. */
export const casThemeVariables = {
  foreground: {
    primary: 'var(--colour-foreground-primary)',
    secondary: 'var(--colour-foreground-secondary)',
    tertiary: 'var(--colour-foreground-tertiary)',
    quaternary: 'var(--colour-foreground-quaternary)',
    'primary-inverse': 'var(--colour-foreground-primary-inverse)',
    'secondary-inverse': 'var(--colour-foreground-secondary-inverse)',
    'tertiary-inverse': 'var(--colour-foreground-tertiary-inverse)',
    'quaternary-inverse': 'var(--colour-foreground-quaternary-inverse)',
    disabled: 'var(--colour-foreground-disabled)',
    brand: 'var(--colour-foreground-brand)',
    'color-yellow': 'var(--colour-foreground-color-yellow)',
    'color-brand': 'var(--colour-foreground-color-brand)',
    'color-green': 'var(--colour-foreground-color-green)',
    'color-lavender': 'var(--colour-foreground-color-lavender)',
    'color-blue': 'var(--colour-foreground-color-blue)',
    info: 'var(--colour-foreground-info)',
    success: 'var(--colour-foreground-success)',
    warning: 'var(--colour-foreground-warning)',
    error: 'var(--colour-foreground-error)',
    neutral: 'var(--colour-foreground-neutral)',
    button: {
      primary: {
        default: 'var(--colour-foreground-button-primary-default)',
        hover: 'var(--colour-foreground-button-primary-hover)',
      },
      secondary: {
        default: 'var(--colour-foreground-button-secondary-default)',
        hover: 'var(--colour-foreground-button-secondary-hover)',
      },
      tertiary: {
        default: 'var(--colour-foreground-button-tertiary-default)',
        hover: 'var(--colour-foreground-button-tertiary-hover)',
      },
    },
  },
  background: {
    primary: 'var(--colour-background-primary)',
    secondary: 'var(--colour-background-secondary)',
    tertiary: 'var(--colour-background-tertiary)',
    quaternary: 'var(--colour-background-quaternary)',
    highlight: 'var(--colour-background-highlight)',
    active: 'var(--colour-background-active)',
    hover: 'var(--colour-background-hover)',
    'hover-brand': 'var(--colour-background-hover-brand)',
    'hover-brand-inverse': 'var(--colour-background-hover-brand-inverse)',
    disabled: 'var(--colour-background-disabled)',
    brand: 'var(--colour-background-brand)',
    'brand-inverse': 'var(--colour-background-brand-inverse)',
    'color-yellow': 'var(--colour-background-color-yellow)',
    'color-brand': 'var(--colour-background-color-brand)',
    'color-green': 'var(--colour-background-color-green)',
    'color-lavender': 'var(--colour-background-color-lavender)',
    'color-blue': 'var(--colour-background-color-blue)',
    info: 'var(--colour-background-info)',
    'info-inverse': 'var(--colour-background-info-inverse)',
    success: 'var(--colour-background-success)',
    'success-inverse': 'var(--colour-background-success-inverse)',
    warning: 'var(--colour-background-warning)',
    'warning-inverse': 'var(--colour-background-warning-inverse)',
    error: 'var(--colour-background-error)',
    'error-inverse': 'var(--colour-background-error-inverse)',
    neutral: 'var(--colour-background-neutral)',
    overlay: 'var(--colour-background-overlay)',
    button: {
      primary: {
        default: 'var(--colour-background-button-primary-default)',
        hover: 'var(--colour-background-button-primary-hover)',
      },
      secondary: {
        default: 'var(--colour-background-button-secondary-default)',
        hover: 'var(--colour-background-button-secondary-hover)',
        'hover-level-2':
          'var(--colour-background-button-secondary-hover-level-2)',
      },
      tertiary: {
        default: 'var(--colour-background-button-tertiary-default)',
        hover: 'var(--colour-background-button-tertiary-hover)',
      },
      utilitarian: {
        error: {
          default: 'var(--colour-background-button-utilitarian-error-default)',
          hover: 'var(--colour-background-button-utilitarian-error-hover)',
        },
        info: {
          default: 'var(--colour-background-button-utilitarian-info-default)',
          hover: 'var(--colour-background-button-utilitarian-info-hover)',
        },
        success: {
          default:
            'var(--colour-background-button-utilitarian-success-default)',
          hover: 'var(--colour-background-button-utilitarian-success-hover)',
        },
        warning: {
          default:
            'var(--colour-background-button-utilitarian-warning-default)',
          hover: 'var(--colour-background-button-utilitarian-warning-hover)',
        },
      },
    },
    input: {
      default: 'var(--colour-background-input-default)',
      hover: 'var(--colour-background-input-hover)',
    },
  },
  border: {
    primary: 'var(--colour-border-primary)',
    secondary: 'var(--colour-border-secondary)',
    tertiary: 'var(--colour-border-tertiary)',
    disabled: 'var(--colour-border-disabled)',
    brand: 'var(--colour-border-brand)',
    info: 'var(--colour-border-info)',
    success: 'var(--colour-border-success)',
    warning: 'var(--colour-border-warning)',
    error: 'var(--colour-border-error)',
    neutral: 'var(--colour-border-neutral)',
    button: {
      primary: {
        default: 'var(--colour-border-button-primary-default)',
        hover: 'var(--colour-border-button-primary-hover)',
      },
      secondary: {
        default: 'var(--colour-border-button-secondary-default)',
        hover: 'var(--colour-border-button-secondary-hover)',
      },
      tertiary: {
        default: 'var(--colour-border-button-tertiary-default)',
        hover: 'var(--colour-border-button-tertiary-hover)',
      },
    },
    card: {
      default: 'var(--colour-border-card-default)',
    },
    'view-more': {
      default: 'var(--colour-border-view-more-default)',
    },
  },
} as const;
